<template>
  <div id="footer">
    <div class="logos">
      <img src="@/assets/images/footer/t-logo.svg" />
      <div class="divider"></div>
      <img src="@/assets/images/footer/lonstar-member.svg" />
    </div>
    <div class="content">
      <div class="socials">
        <a href="https://twitter.com/Rangers" target="_blank"><img src="@/assets/images/footer/x.svg" /></a>
        <a href="https://www.youtube.com/@Rangers/" target="_blank"><img src="@/assets/images/footer/youtube.svg" /></a>
        <a href="https://www.instagram.com/rangers/" target="_blank"><img
            src="@/assets/images/footer/instagram.svg" /></a>
        <a href="https://www.facebook.com/Rangers/" target="_blank"><img
            src="@/assets/images/footer/facebook.svg" /></a>
      </div>
      <div class="links">
        <a href="https://www.mlb.com/official-information/terms-of-use" target="_blank">mlb.com Terms of Use</a>
        /
        <a href="https://www.mlb.com/official-information/privacy-policy" target="_blank">mlb.com Privacy Policy</a>
      </div>
      <p>Major League Baseball trademarks and copyrights are used with permission of MLB Advanced Media, LP All rights
        reserved</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
#footer {
  width: 100%;
  background: var(--STH-Blue-Gradient, linear-gradient(0deg, #14264C 0%, #1E376D 100%));
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.25);
  padding: 25px 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: $md) {
    flex-direction: column;
    gap: 20px;
  }

  .logos {
    display: flex;
    align-items: center;
    gap: 25px;

    .divider {
      width: 1px;
      height: 57px;
      background-color: #fff;
    }


  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;

    @media screen and (max-width: $md) {
      align-items: center;
    }


    .socials {
      display: flex;
      gap: 6px;
    }

    .links {
      color: rgba(191, 184, 175, 0.50);
      font-family: Gotham;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 16px;

      a {
        color: var(--STH-White, #FFF);
        text-align: right;
        font-family: Gotham;
        font-size: 14px;
        font-style: normal;
        font-weight: normal;
        line-height: 22px;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: auto;
        text-decoration-thickness: 5%;
        text-underline-offset: 20%;
        text-underline-position: from-font;
      }
    }

    p {
      color: var(--STH-White, #FFF);
      text-align: right;

      font-family: Gotham;
      font-size: 12px;
      font-style: normal;
      font-weight: normal;
      line-height: 18px;
      /* 150% */
      margin-bottom: 0;

      @media screen and (max-width: $md) {
      text-align: center;
    }
    }
  }
}
</style>
